import API from '@/services/api';

export default {
  fetchTrainersTable() {
    return API().get('dashboard/trainers-table');
  },
  fetchTrainerTable(id) {
    return API().get(`dashboard/trainers-table/trainer/${id}`);
  },
  fetchTrainerActivityChart(id) {
    return API().get(`dashboard/trainers-activity-chart/trainer/${id}`);
  },
  fetchSchoolCountByCountry() {
    return API().get('dashboard/school-count');
  },
  fetchActiveTeacherCountByCountry() {
    return API().get('dashboard/teacher-count');
  },
  fetchActiveStudentCountByCountry() {
    return API().get('dashboard/student-count');
  },
  fetchMalawiTrainersActivity() {
    return API().get('dashboard/trainers-activity/malawi');
  },
  fetchNamibiaTrainersActivity() {
    return API().get('dashboard/trainers-activity/namibia');
  },
  fetchSchoolsMap() {
    return API().get('dashboard/schools-map');
  },
  fetchStructureTable() {
    return API().get('dashboard/schools-structure');
  },
  fetchTeacherTrainingModuleTable() {
    return API().get('dashboard/teachers-training-table');
  },
  fetchStudentAttendanceTable() {
    return API().get('dashboard/student-attendance-table');
  },
};